import store from '@/store'
import request from '@/utils/request'
import { getLocalApiOrigin, getPreferredUploadBaseURL, isBrowserLocalhost } from '@/config/env'

function rewriteUploadUrlToLocal(url) {
  if (!url || typeof url !== 'string' || !isBrowserLocalhost()) return url

  const localOrigin = getLocalApiOrigin()
  if (!localOrigin) return url

  const normalized = url.trim()
  const apiPrefix = '/api/'
  const uploadsPath = '/uploads/'

  if (/^https?:\/\//i.test(normalized)) {
    try {
      const parsed = new URL(normalized)
      if (parsed.pathname.startsWith(apiPrefix)) {
        return `${localOrigin}${parsed.pathname}${parsed.search}${parsed.hash}`
      }
      if (parsed.pathname.startsWith(uploadsPath)) {
        return `${localOrigin}/api${parsed.pathname}${parsed.search}${parsed.hash}`
      }
    } catch (error) {
      return normalized
    }
  }

  if (normalized.startsWith(apiPrefix)) {
    return `${localOrigin}${normalized}`
  }

  if (normalized.startsWith(uploadsPath)) {
    return `${localOrigin}/api${normalized}`
  }

  return normalized
}

function normalizeUploadResponse(response) {
  const data = response?.data?.data
  if (!data || typeof data !== 'object') return response

  ;['fileUrl', 'url', 'filePath'].forEach((key) => {
    if (typeof data[key] === 'string') {
      data[key] = rewriteUploadUrlToLocal(data[key])
    }
  })

  return response
}


// 本地免登（联调快速打通）
export function devLogin(params) {
  return request({
    url: '/auth/devLogin',
    method: 'post',
    params
  })
}

// 本地管理员免登（仅 local）
export function devAdminLogin(params) {
  return request({
    url: '/auth/devAdminLogin',
    method: 'post',
    params
  })
}


// 用户登录
export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

// 获取验证码
export function authCode(data) {
  return request({
    url: "/auth/generate",
    method: "get",
    data
  })
}

// 获取用户信息
export function getAuthInfo(data) {
  return request({
    url: "/auth/info",
    method: "get",
    data
  })
}

// 上传用户头像
export function upLoadAvatar(data) {
  return request({
    url: "/local-file/upload/dto",
    method: "post",
    baseURL: getPreferredUploadBaseURL(),
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(normalizeUploadResponse)
}

export function upLoadImg(data) {
  return request({
    url: "/local-file/upload/dtot",
    method: "post",
    baseURL: getPreferredUploadBaseURL(),
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(normalizeUploadResponse)
}

// 用户管理相关接口
export function getUserList(params) {
  return request({
    url: '/admin/user/list',
    method: 'get',
    params
  })
}

// 获取商家列表
export function getMerchantList(params) {
  return request({
    url: '/user/merchant/list',
    method: 'get',
    params
  })
}

// 添加用户
export function addUser(data) {
  return request({
    url: '/user/add',
    method: 'post',
    data
  })
}

// 更新用户
export function updateUser(data) {
  return request({
    url: '/admin/user/edit',
    method: 'put',
    data
  })
}

// 重置密码
export function resetUser(data) {
  return request({
    url: '/admin/user/reset',
    method: 'post',
    data
  })
}

//  设置用户的上级
export function setsuperior(data) {
  return request({
    url: '/admin/user/setsuperior',
    method: 'put',
    data
  })
}

// 删除用户
export function deleteUser(id) {
  return request({
    url: `/admin/user/delUser/${id}`,
    method: 'delete'
  })
}

// 商品管理相关接口
export function getProductList(params) {
  return request({
    url: '/admin/product/list',
    method: 'get',
    params
  })
}
// 上传商品图
export function upLoadPeojectMain(data) {
  return request({
    url: "/local-file/upload",
    method: "post",
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
// 上传商品详情图
export function upLoadPeojectDetail(data) {
  return request({
    url: "/local-file/upload/batch",
    method: "post",
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function addProduct(data) {
  return request({
    url: '/admin/product/add',
    method: 'post',
    data
  })
}

export function updateProduct(data) {
  return request({
    url: '/admin/product/update',
    method: 'put',
    data
  })
}

export function updateProductStatus(data) {
  return request({
    url: '/admin/product/status',
    method: 'put',
    data
  })
}

export function deleteProduct(id) {
  return request({
    url: `/admin/product/${id}`,
    method: 'delete'
  })
}

export function getProductDetail(id) {
  return request({
    url: `/admin/product/${id}`,
    method: 'get'
  })
}

// 上传图片
export function uploadImage(data) {
  return request({
    url: '/api/users/updateAvatar',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 订单管理相关接口
export function getOrderList(params) {
  return request({
    url: '/admin/order/list',
    method: 'get',
    params
  })
}

export function getOrderDetail(id) {
  return request({
    url: `/admin/order/${id}`,
    method: 'get'
  })
}

// 根据订单号获取订单详情
export function getOrderDetailByOrderNo(orderNo) {
  return request({
    url: `/admin/order/by-no/${orderNo}`,
    method: 'get'
  })
}

// 订单交易
export function getTransactionList(params) {
  return request({
    url: '/admin/wallet/transaction/list',
    method: 'get',
    params
  })
}

// 订单发货
export function shipOrder(data) {
  return request({
    url: '/order/ship',
    method: 'post',
    data
  })
}

// 取消订单
export function cancelOrder(data) {
  // data: { id, reason }
  const { id, reason } = data || {}
  return request({
    url: `/admin/order/${id}/cancel`,
    method: 'put',
    params: { reason: reason || '' }
  })
}

// 删除订单
export function deleteOrder(id) {
  return request({
    url: `/order/delete/${id}`,
    method: 'delete'
  })
}

// 查询物流信息（根据订单号）
export function queryLogistics(orderNo) {
  return request({
    url: '/logistics/query',
    method: 'get',
    params: { orderNo }
  })
}

// 查询物流信息（根据快递公司和单号）
export function queryLogisticsByNo(company, trackingNo) {
  return request({
    url: '/logistics/query-by-no',
    method: 'get',
    params: { company, trackingNo }
  })
}

// 获取微信运力公司列表
export function getDeliveryList() {
  return request({
    url: '/wx/logistics/delivery-list',
    method: 'get'
  })
}

// 查询物流详情（通过微信API）
export function queryLogisticsDetail(orderNo) {
  return request({
    url: '/wx/logistics/query',
    method: 'get',
    params: { orderNo }
  })
}

// 商品分类相关接口
export function getCategoryList(params) {
  return request({
    url: '/admin/category/list',
    method: 'get',
    params
  })
}

export function addCategory(data) {
  return request({
    url: '/admin/category/add',
    method: 'post',
    data
  })
}

export function updateCategory(data) {
  return request({
    url: '/admin/category/update',
    method: 'put',
    data
  })
}

export function deleteCategory(id) {
  return request({
    url: `/admin/category/${id}`,
    method: 'delete'
  })
}

export function getCategoryTree(userId) {
  return request({
    url: `/product/category/${userId}/tree`,
    method: 'get'
  })
}

// 财务管理相关接口
export function getFinanceList(params) {
  return request({
    url: '/finance/list',
    method: 'get',
    params
  })
}

// 数据统计相关接口
export function getDashboardData(params) {
  return request({
    url: '/admin/statistics/dashboard',
    method: 'get',
    params
  })
}

// 获取系统概览统计
export function getSystemOverview() {
  return request({
    url: '/admin/statistics/overview',
    method: 'get'
  })
}

// 获取完整统计数据
export function getFullStatistics() {
  return request({
    url: '/admin/statistics/full',
    method: 'get'
  })
}

// 获取实时数据
export function getRealTimeData() {
  return request({
    url: '/admin/statistics/realtime',
    method: 'get'
  })
}

// 消息管理相关接口
export function getMessageList(params) {
  return request({
    url: '/api/message/list',
    method: 'get',
    params
  })
}

// 聊天记录查询相关接口
export function getChatRecords(params) {
  return request({
    url: '/api/message/chat/records',
    method: 'get',
    params
  })
}

export function getChatUsers() {
  return request({
    url: '/api/message/chat/users',
    method: 'get'
  })
}

// 系统设置相关接口
// 会员套餐列表
// @update BlackJack 2026-01-12 修改接口路径为 /admin/package/list
export function getMembershipList(params) {
  return request({
    url: '/admin/package/list',
    method: 'get',
    params
  })
}

export function getDistributorSetting() {
  return request({
    url: '/setting/distributor',
    method: 'get'
  })
}

export function getPaymentProviders() {
  return request({
    url: '/setting/payment-provider/list',
    method: 'get'
  })
}

/**
 * 添加支付服务商
 * @author BlackJack
 * @date 2026-01-14
 */
export function addPaymentProvider(data) {
  return request({
    url: '/setting/payment-provider',
    method: 'post',
    data
  })
}

/**
 * 更新支付服务商
 * @author BlackJack
 * @date 2026-01-14
 */
export function updatePaymentProvider(id, data) {
  return request({
    url: `/setting/payment-provider/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除支付服务商
 * @author BlackJack
 * @date 2026-01-14
 */
export function deletePaymentProvider(id) {
  return request({
    url: `/setting/payment-provider/${id}`,
    method: 'delete'
  })
}

/**
 * 设置默认支付服务商
 * @author BlackJack
 * @date 2026-01-14
 */
export function setDefaultProvider(id) {
  return request({
    url: `/setting/payment-provider/${id}/default`,
    method: 'post'
  })
}

export function updatePaymentConfig(data) {
  return request({
    url: '/setting/payment-config/update',
    method: 'put',
    data
  })
}

export function getDomainConfig() {
  return request({
    url: '/setting/domain',
    method: 'get'
  })
}

export function getAgentSetting() {
  return request({
    url: '/setting/agent',
    method: 'get'
  })
}

export function getAdminList(params) {
  return request({
    url: '/administrator/list',
    method: 'get',
    params
  })
}

export function updatePassword(data) {
  return request({
    url: '/user/password/update',
    method: 'put',
    data
  })
}

// 添加管理员
export function addAdmin(data) {
  return request({
    url: '/api/users',
    method: 'post',
    data
  })
}

// 更新管理员
export function updateAdmin(data) {
  return request({
    url: '/admin/user/edit',
    method: 'put',
    data
  })
}

// 删除管理员
export function deleteAdmin_v(id) {
  return request({
    url: `/admin/user/delUser/${id}`,
    method: 'delete',
  })
}

// 删除管理员
export function deleteAdmin(id) {
  return request({
    url: `/setting/admin/delete/${id}`,
    method: 'delete'
  })
}

// 获取角色列表
export function getRoleList() {
  return request({
    url: '/setting/role/list',
    method: 'get'
  })
}

// 返回所有角色
export function getAllRoles() {
  return request({
    url: "/api/roles/all"
  })
}

// 添加角色
export function addRole(data) {
  return request({
    url: '/setting/role/add',
    method: 'post',
    data
  })
}

// 更新角色
export function updateRole(data) {
  return request({
    url: '/setting/role/update',
    method: 'put',
    data
  })
}

// 删除角色
export function deleteRole(id) {
  return request({
    url: `/setting/role/delete/${id}`,
    method: 'delete'
  })
}

// 获取角色权限
export function getRolePermissions(roleId) {
  return request({
    url: `/setting/role/permissions/${roleId}`,
    method: 'get'
  })
}

// 更新角色权限
export function updateRolePermissions(data) {
  return request({
    url: '/setting/role/permissions/update',
    method: 'put',
    data
  })
}

// 更新域名配置
export function updateDomainConfig(data) {
  return request({
    url: '/setting/domain/update',
    method: 'put',
    data
  })
}

// 添加域名
export function addDomain(data) {
  return request({
    url: '/setting/domain/add',
    method: 'post',
    data
  })
}

// 删除域名
export function deleteDomain(id) {
  return request({
    url: `/setting/domain/delete/${id}`,
    method: 'delete'
  })
}

// 更新代理商设置
export function updateAgentSetting(data) {
  return request({
    url: '/setting/agent/update',
    method: 'put',
    data
  })
}

// 更新分销商设置
export function updateDistributorSetting(data) {
  return request({
    url: '/setting/distributor/update',
    method: 'put',
    data
  })
}

// 更新会员套餐
// @update BlackJack 2026-01-12 修改接口路径为 /admin/package
export function updateMembership(data) {
  return request({
    url: '/admin/package',
    method: 'put',
    data
  })
}

// 添加会员套餐
// @update BlackJack 2026-01-12 修改接口路径为 /admin/package
export function addMembership(data) {
  return request({
    url: '/admin/package',
    method: 'post',
    data
  })
}

// 删除会员套餐
// @update BlackJack 2026-01-12 修改接口路径为 /admin/package/{id}
export function deleteMembership(id) {
  return request({
    url: `/admin/package/${id}`,
    method: 'delete'
  })
}

// 日志配置相关API

// 更新日志配置
export function updateLogConfig(data) {
  return request({
    url: '/setting/log-config/update',
    method: 'put',
    data
  })
}

// 获取日志列表
export function getLogs(params) {
  return request({
    url: '/setting/logs',
    method: 'get',
    params
  })
}

// 导出日志
export function exportLogs(params) {
  return request({
    url: '/setting/logs/export',
    method: 'get',
    params,
    responseType: 'blob' // 指定响应类型为blob，用于文件下载
  })
}

// 清理日志
export function clearLogs(data) {
  return request({
    url: '/setting/logs/clear',
    method: 'post',
    data
  })
}

// 上传文件
export function getLocalStorage(data) {
  return request({
    url: `/api/localStorage?page=${data.page}&size=${data.size}`
  })
}

// 删除文件
export function delLocalStorage(data) {
  return request({
    url: "/api/localStorage",
    method: "delete",
    data
  })
}
// 导出文件
export function exportFile(data) {
  return request({
    url: "/api/localStorage/download",
    data,
    responseType: "arraybuffer"
  })
}

// 修改文件
export function editFile(data) {
  return request({
    url: "/api/localStorage",
    method: "put",
    data
  })
}

export function searchFile(data) {
  return request({
    url: `/api/localStorage?page=${data.page}&size=${data.size}&blurry=${data.keyword}`
  })
}

//查询普通用户（商家管理）
export function getCommonUser(params) {
  return request({
    url: "/admin/merchant/list",
    method: "get",
    params
  })
}

export function updateCommonUser(data) {
  return request({
    url: "/api/commUser",
    method: "put",
    data
  })
}

export function deleteCommonUser(params) {
  return request({
    url: "/api/commUser",
    method: "delete",
    params
  })
}

// 查询部门
export function getDept(data) {
  return request({
    url: "/api/dept",
    data
  })
}

export function getDeptFromId(data) {
  return request({
    url: `/api/dept?pid=${data}`,
    data
  })
}

export function getJob(data) {
  return request({
    url: "/api/job",
    data
  })
}

// export function editUser(data) {
// 	return request({
// 		url: "/api/users",
// 		method: "put",
// 		data
// 	})
// }


export function getOrder(params) {
  return request({
    url: "/api/commUser",
    method: "get",
    params
  })
}

  //管理员接口
export function getAdministratorList(params) {
  return request({
    url: '/administrator/list',
    method: 'get',
    params
  })
}
// 管理员添加
  export function addAdministrator(data) {
    return request({
      url: '/administrator',
      method: 'post',
      data
    })
  }
// 管理员修改
  export function updateAdministrator(data) {
    return request({
      url: '/administrator',
      method: 'put',
      data
    })
}
// 删除管理员
export function deleteAdministrator(id) {
  return request({
    url: `/administrator/${id}`,
    method: 'delete'
  })
}
  // 重置管理员密码
export function resetAdministrator(data) {
  return request({
    url: `/administrator/reset`,
    method: 'put',
     data
  })
}
// 重置管理员密码
export function validatPassword(params) {
  return request({
    url: `/administrator/validate-password`,
    method: 'get',
    params
  })
}


//自动回复消息设置
export function getAdminReplyList(params) {
  return request({
    url: '/admin/reply/list',
    method: 'get',
    params
  })
}

export function addAdminReply(data) {
  return request({
    url: '/admin/reply/add',
    method: 'post',
    data
  })
}

export function updateAdminReply(data) {
  return request({
    url: '/admin/reply/update',
    method: 'put',
    data
  })
}

export function deleteAdminReply(id) {
  return request({
    url: `/admin/reply/delete/${id}`,
    method: 'delete'
  })
}

export function setttingTopAdminReply(id,isTop) {
  return request({
    url: '/admin/reply/set-top?id='+id+'&isTop='+isTop,
    method: 'post',
  })
}

// ======================== 微信开放平台配置相关接口 ========================

/**
 * 获取微信开放平台配置
 * 返回 config（appId/appSecret/callbackUrl/signKey/allowedRedirectHosts）、source、cacheRemainingSeconds
 */
export function getWxOpenConfig() {
  return request({
    url: '/admin/wx-open-config',
    method: 'get'
  })
}

/**
 * 更新微信开放平台配置
 * @param {object} data 配置数据
 * @param {string} data.appId 微信开放平台 AppID
 * @param {string} data.appSecret 微信开放平台 AppSecret
 * @param {string} data.callbackUrl 微信回调地址
 * @param {string} data.signKey 签名密钥
 * @param {string[]} data.allowedRedirectHosts 租户域名白名单
 */
export function updateWxOpenConfig(data) {
  return request({
    url: '/admin/wx-open-config',
    method: 'put',
    data
  })
}

/**
 * 重置微信开放平台配置为 YAML 默认值
 * 清除 Redis 中的配置，系统回退到 application.yml 中的值
 */
export function resetWxOpenConfig() {
  return request({
    url: '/admin/wx-open-config',
    method: 'delete'
  })
}

//系统设置
export function getSystemConfig(param) {
  return request({
    url: '/admin/system-config/by-group/'+param,
    method: 'get',
  })
}

export function addSystemConfig(data) {
  return request({
    url: '/admin/system-config/batch-update',
    method: 'post',
    data
  })
}

export function getMiniProgramLaunchConfig() {
  return request({
    url: '/admin/system-config/mini-program-launch',
    method: 'get'
  })
}

export function updateMiniProgramLaunchConfig(data) {
  return request({
    url: '/admin/system-config/mini-program-launch',
    method: 'put',
    data
  })
}

// 根据配置键获取配置值
export function getSystemConfigByKey(configKey) {
  return request({
    url: '/admin/system-config/by-key',
    method: 'get',
    params: { configKey }
  })
}

export function getSmsAdminConfig() {
  return request({
    url: '/admin/sms-config',
    method: 'get'
  })
}

export function updateSmsAdminConfig(data) {
  return request({
    url: '/admin/sms-config',
    method: 'put',
    data
  })
}

// 添加单个系统配置
export function addSingleSystemConfig(data) {
  return request({
    url: '/admin/system-config',
    method: 'post',
    data
  })
}

// ======================== 营销配置相关接口 ========================

/**
 * 获取营销配置
 * @param {string} type 配置类型: CLIENT_DOWNLOAD, WECHAT_FOLLOW
 */
export function getMarketingConfig(type) {
  return request({
    url: `/marketing-config/${type}`,
    method: 'get'
  })
}

/**
 * 更新营销配置
 * @param {object} data 配置数据
 */
export function updateMarketingConfig(data) {
  return request({
    url: '/marketing-config/update',
    method: 'post',
    data
  })
}

/**
 * 获取营销配置历史记录
 * @param {string} type 配置类型
 * @param {object} params 分页参数
 */
export function getMarketingHistory(type, params = {}) {
  return request({
    url: `/marketing-config/history/${type}`,
    method: 'get',
    params
  })
}

/**
 * 回滚营销配置
 * @param {number} historyId 历史记录ID
 */
export function rollbackMarketingConfig(historyId) {
  return request({
    url: `/marketing-config/rollback/${historyId}`,
    method: 'post'
  })
}

// 更新单个系统配置
export function updateSystemConfig(data) {
  return request({
    url: '/admin/system-config',
    method: 'put',
    data
  })
}

//会员套餐
export function getAdminPackageList(params) {
  return request({
    url: '/admin/package/list',
    method: 'get',
    params
  })
}

export function addAdminPackage(data) {
  return request({
    url: '/admin/package',
    method: 'post',
    data
  })
}

export function updateAdminPackage(data) {
  return request({
    url: '/admin/package',
    method: 'put',
    data
  })
}
export function deleteAdminPackage(id) {
  return request({
    url: `/admin/package/${id}`,
    method: 'delete'
  })
}
//代理商套餐
export function getAdminPackageCardList(params) {
  return request({
    url: '/admin/package-card/data-list',
    method: 'get',
    params
  })
}
export function updateAdminPackageCard(data) {
  return request({
    url: '/admin/package-card/save-packages',
    method: 'post',
    data
  })
}

export function deletePackageCard(id) {
  return request({
    url: `/admin/package-card/${id}`,
    method: 'delete',
  })
}

//发布公告
export function getAdminArticleList(params) {
  return request({
    url: '/admin/article/list',
    method: 'get',
    params
  })
}

export function addAdminArticle(data) {
  return request({
    url: '/admin/article',
    method: 'post',
    data
  })
}

export function updateAdminArticle(data) {
  return request({
    url: '/admin/article',
    method: 'put',
    data
  })
}
export function deleteAdminArticle(id) {
  return request({
    url: `/admin/article/${id}`,
    method: 'delete'
  })
}
//域名管理

export function getAdminDomainList(params) {
  return request({
    url: '/admin/domain/list',
    method: 'get',
    params
  })
}

export function addAdminDomain(data) {
  return request({
    url: '/admin/domain',
    method: 'post',
    data
  })
}

export function updateAdminDomain(data) {
  return request({
    url: '/admin/domain',
    method: 'put',
    data
  })
}
export function deleteAdminDomain(id) {
  return request({
    url: `/admin/domain/${id}`,
    method: 'delete'
  })
}
//订单投诉

export function getAdminComplaintList(params) {
  return request({
    url: '/admin/complaint-order/list',
    method: 'get',
    params
  })
}

export function addAdminComplaint(data) {
  return request({
    url: '/admin/complaint-order',
    method: 'post',
    data
  })
}

export function updateAdminComplaint(data) {
  return request({
    url: '/admin/complaint-order',
    method: 'put',
    data
  })
}

// ======================== 用户人气基数管理相关接口 ========================

/**
 * 获取用户人气基数
 * @param {number|string} userId 用户ID
 */
export function getUserBaseVisitCount(userId) {
  return request({
    url: `/admin/user/${userId}/baseVisitCount`,
    method: 'get'
  })
}

/**
 * 设置用户人气基数
 * @param {number|string} userId 用户ID
 * @param {number} baseVisitCount 人气基数
 */
export function setUserBaseVisitCount(userId, baseVisitCount) {
  return request({
    url: `/admin/user/${userId}/baseVisitCount`,
    method: 'put',
    data: { baseVisitCount }
  })
}

/**
 * 调整用户人气基数
 * @param {number|string} userId 用户ID
 * @param {number} delta 增减值，支持正负数
 */
export function adjustUserBaseVisitCount(userId, delta) {
  return request({
    url: `/admin/user/${userId}/baseVisitCount/adjust`,
    method: 'put',
    data: { delta }
  })
}
export function deleteAdminComplaint(id) {
  return request({
    url: `/admin/complaint-order/${id}`,
    method: 'delete'
  })
}

// ======================== 平台介入管理相关接口 ========================

/**
 * 获取平台介入列表
 * @param {object} params 查询参数
 * @param {number} params.page 页码
 * @param {number} params.size 每页数量
 * @param {number} params.status 状态：0-待受理, 1-受理中, 2-判决中, 3-已判决
 * @author ysg
 * @date 2026-02-08
 */
export function getInterventionList(params) {
  return request({
    url: '/admin/order/intervention/list',
    method: 'get',
    params
  })
}

/**
 * 获取介入详情
 * @param {string} interventionNo 介入编号
 * @author ysg
 * @date 2026-02-08
 */
export function getInterventionDetail(interventionNo) {
  return request({
    url: `/admin/order/intervention/${interventionNo}`,
    method: 'get'
  })
}

/**
 * 管理员受理介入
 * @param {string} interventionNo 介入编号
 * @author ysg
 * @date 2026-02-08
 */
export function acceptIntervention(interventionNo) {
  return request({
    url: `/admin/order/intervention/${interventionNo}/accept`,
    method: 'post'
  })
}

/**
 * 管理员开始判决
 * @param {string} interventionNo 介入编号
 * @author ysg
 * @date 2026-02-08
 */
export function startJudgment(interventionNo) {
  return request({
    url: `/admin/order/intervention/${interventionNo}/start-judgment`,
    method: 'post'
  })
}

/**
 * 管理员做出判决
 * @param {string} interventionNo 介入编号
 * @param {object} data 判决数据
 * @param {number} data.judgmentResult 判决结果：1-支持买家, 2-支持卖家, 3-各退一步
 * @param {string} data.judgmentDesc 判决说明
 * @param {number} data.compensationAmount 补偿金额（可选）
 * @author ysg
 * @date 2026-02-08
 */
export function judgeIntervention(interventionNo, data) {
  return request({
    url: `/admin/order/intervention/${interventionNo}/judge`,
    method: 'post',
    data
  })
}

/**
 * 获取介入统计数据
 * @author ysg
 * @date 2026-02-08
 */
export function getInterventionStatistics() {
  return request({
    url: '/admin/order/intervention/statistics',
    method: 'get'
  })
}

/**
 * 添加介入备注
 * @param {string} interventionNo 介入编号
 * @param {object} data 备注数据
 * @param {string} data.remark 备注内容
 * @author ysg
 * @date 2026-02-08
 */
export function addInterventionRemark(interventionNo, data) {
  return request({
    url: `/admin/order/intervention/${interventionNo}/remark`,
    method: 'post',
    data
  })
}

// ======================== 消息管理相关接口 ========================

// ---------- 聊天管理 ----------
// 获取当前用户的聊天会话列表（用于管理端自己的会话）
export function getAdminChatSessionList(params) {
  return request({
    url: '/chat/session/list',
    method: 'get',
    params
  })
}

// 获取所有用户的聊天会话列表（管理端专用 - 推荐使用）
export function getAllChatSessions(params) {
  return request({
    url: '/admin/chat/sessions/all',
    method: 'get',
    params
  })
}

// 获取聊天历史消息
export function getAdminChatMessageList(params) {
  return request({
    url: '/chat/message/list',
    method: 'get',
    params
  })
}

// 发送消息（HTTP方式）
export function sendChatMessage(data) {
  return request({
    url: '/chat/send',
    method: 'post',
    data
  })
}

// 标记消息已读
export function markChatMessageRead(data) {
  return request({
    url: '/chat/message/read',
    method: 'post',
    data
  })
}

// 批量标记消息已读
export function batchMarkChatMessageRead(data) {
  return request({
    url: '/chat/message/batch-read',
    method: 'post',
    data
  })
}

// 获取会话未读数
export function getChatSessionUnreadCount(sessionId) {
  return request({
    url: `/chat/session/${sessionId}/unread`,
    method: 'get'
  })
}

// 获取总未读数
export function getChatTotalUnreadCount() {
  return request({
    url: '/chat/unread/count',
    method: 'get'
  })
}

// 获取或创建会话
export function getOrCreateChatSession(toUserId) {
  return request({
    url: '/chat/session/get-or-create',
    method: 'get',
    params: { toUserId }
  })
}

// ---------- 系统消息/通知 ----------
// 获取用户消息列表
export function getUserMessageList(params) {
  return request({
    url: '/user/messages',
    method: 'get',
    params
  })
}

// 获取未读消息数量
export function getMessageUnreadCount() {
  return request({
    url: '/user/messages/unread/count',
    method: 'get'
  })
}

// 标记消息为已读
export function markMessageAsRead(messageId) {
  return request({
    url: `/user/messages/${messageId}/read`,
    method: 'post'
  })
}

// 标记所有消息为已读
export function markAllMessagesAsRead() {
  return request({
    url: '/user/messages/read/all',
    method: 'post'
  })
}

// 删除消息
export function deleteMessage(messageId) {
  return request({
    url: `/user/messages/${messageId}`,
    method: 'delete'
  })
}

// ---------- 信箱系统 ----------
// 获取信箱消息列表
export function getInboxMessageList(params) {
  return request({
    url: '/inbox/list',
    method: 'get',
    params
  })
}

// 获取信箱统计
export function getInboxStats() {
  return request({
    url: '/inbox/stats',
    method: 'get'
  })
}

// 获取信箱未读数
export function getInboxUnreadCount() {
  return request({
    url: '/inbox/unread/count',
    method: 'get'
  })
}

// 按类型获取未读数
export function getInboxUnreadCountByType(type) {
  return request({
    url: `/inbox/unread/${type}`,
    method: 'get'
  })
}

// 标记信箱消息已读
export function markInboxMessageRead(ids) {
  return request({
    url: '/inbox/mark-read',
    method: 'post',
    data: ids
  })
}

// 删除信箱消息
export function deleteInboxMessage(ids) {
  return request({
    url: '/inbox/delete',
    method: 'post',
    data: ids
  })
}

// 创建系统通知（管理员）
export function createSystemNotification(data) {
  return request({
    url: '/inbox/system-notification',
    method: 'post',
    params: data
  })
}

// 创建官方公告（管理员）
export function createAnnouncement(data) {
  return request({
    url: '/inbox/announcement',
    method: 'post',
    params: data
  })
}

// ---------- 管理端专用接口 ----------
// 获取所有用户的会话列表（管理端）
export function getAdminAllChatSessions(params) {
  return request({
    url: '/admin/chat/sessions/all',
    method: 'get',
    params
  })
}

// 搜索聊天消息（管理端）
export function searchAdminChatMessages(params) {
  return request({
    url: '/admin/chat/messages/search',
    method: 'get',
    params
  })
}

// 获取聊天统计信息（管理端）
export function getAdminChatStatistics() {
  return request({
    url: '/admin/chat/statistics',
    method: 'get'
  })
}

// 获取会话详细信息（管理端）
export function getAdminSessionDetail(sessionId) {
  return request({
    url: `/admin/chat/session/${sessionId}/detail`,
    method: 'get'
  })
}

// 删除聊天消息（管理端）
export function deleteAdminChatMessage(messageId) {
  return request({
    url: `/admin/chat/message/${messageId}`,
    method: 'delete'
  })
}


// ======================== 会员权益管理相关接口 ========================

/**
 * 获取权益列表
 * @author BlackJack
 * @date 2026-01-12
 */
export function getBenefitList() {
  return request({
    url: '/admin/benefits',
    method: 'get'
  })
}

/**
 * 获取启用状态的权益列表
 * @author BlackJack
 * @date 2026-01-12
 */
export function getEnabledBenefitList() {
  return request({
    url: '/admin/benefits/enabled',
    method: 'get'
  })
}

/**
 * 获取权益详情
 * @param {number} id 权益ID
 * @author BlackJack
 * @date 2026-01-12
 */
export function getBenefitDetail(id) {
  return request({
    url: `/admin/benefits/${id}`,
    method: 'get'
  })
}

/**
 * 创建权益
 * @param {object} data 权益信息
 * @author BlackJack
 * @date 2026-01-12
 */
export function createBenefit(data) {
  return request({
    url: '/admin/benefits',
    method: 'post',
    data
  })
}

/**
 * 更新权益
 * @param {number} id 权益ID
 * @param {object} data 权益信息
 * @author BlackJack
 * @date 2026-01-12
 */
export function updateBenefit(id, data) {
  return request({
    url: `/admin/benefits/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除权益
 * @param {number} id 权益ID
 * @author BlackJack
 * @date 2026-01-12
 */
export function deleteBenefit(id) {
  return request({
    url: `/admin/benefits/${id}`,
    method: 'delete'
  })
}

/**
 * 检查权益是否被套餐关联
 * @param {number} id 权益ID
 * @author BlackJack
 * @date 2026-01-12
 */
export function checkBenefitLinked(id) {
  return request({
    url: `/admin/benefits/${id}/linked`,
    method: 'get'
  })
}

// ======================== 套餐权益关联相关接口 ========================

/**
 * 获取套餐详情（包含权益）
 * @param {number} id 套餐ID
 * @author BlackJack
 * @date 2026-01-12
 */
export function getPackageWithBenefits(id) {
  return request({
    url: `/admin/package/detail/${id}`,
    method: 'get'
  })
}

/**
 * 获取套餐的权益列表
 * @param {number} id 套餐ID
 * @author BlackJack
 * @date 2026-01-12
 */
export function getPackageBenefits(id) {
  return request({
    url: `/admin/package/${id}/benefits`,
    method: 'get'
  })
}

/**
 * 创建套餐（支持权益配置）
 * @param {object} data 套餐信息（包含benefits数组）
 * @author BlackJack
 * @date 2026-01-12
 */
export function createPackageWithBenefits(data) {
  return request({
    url: '/admin/package',
    method: 'post',
    data
  })
}

/**
 * 更新套餐（支持权益配置）
 * @param {object} data 套餐信息（包含benefits数组）
 * @author BlackJack
 * @date 2026-01-12
 */
export function updatePackageWithBenefits(data) {
  return request({
    url: '/admin/package',
    method: 'put',
    data
  })
}


/**
 * 更新套餐状态
 * @param {number} id 套餐ID
 * @param {number} status 状态：0-禁用，1-启用
 * @author BlackJack
 * @date 2026-01-12
 */
export function updateMembershipStatus(id, status) {
  return request({
    url: `/admin/package/${id}/status`,
    method: 'put',
    params: { status }
  })
}

// ======================== 卡密管理相关接口 ========================

/**
 * 获取卡密列表（分页）
 * @param {object} params 查询参数
 * @param {number} params.page 页码
 * @param {number} params.pageSize 每页数量
 * @param {number} params.packageId 套餐ID
 * @param {number} params.agentId 代理商ID
 * @param {number} params.isActivated 激活状态：0-未激活，1-已激活
 * @param {string} params.startTime 创建时间开始
 * @param {string} params.endTime 创建时间结束
 * @param {string} params.cardAccount 卡号（模糊搜索）
 * @author BlackJack
 * @date 2026-01-12
 */
export function getCardSecretList(params) {
  return request({
    url: '/admin/cards',
    method: 'get',
    params
  })
}

/**
 * 获取卡密详情
 * @param {number} id 卡密ID
 * @author BlackJack
 * @date 2026-01-12
 */
export function getCardSecretDetail(id) {
  return request({
    url: `/admin/cards/${id}`,
    method: 'get'
  })
}

/**
 * 导出卡密Excel
 * @param {object} params 查询参数
 * @param {number} params.packageId 套餐ID
 * @param {number} params.agentId 代理商ID
 * @param {number} params.isActivated 激活状态
 * @param {string} params.startTime 创建时间开始
 * @param {string} params.endTime 创建时间结束
 * @author BlackJack
 * @date 2026-01-12
 */
export function exportCardSecrets(params) {
  return request({
    url: '/admin/cards/export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

/**
 * 生成代理商卡密
 * @param {object} data 参数
 * @param {number} data.agentPackageId 代理商套餐ID
 * @param {number} data.quantity 生成数量
 * @author BlackJack
 * @date 2026-02-15
 */
export function generateAgentCards(data) {
  return request({
    url: '/admin/agent/cards/generate',
    method: 'post',
    params: data
  })
}


// ======================== 代理商套餐管理相关接口 ========================

/**
 * 获取代理商套餐列表（分页）
 * @param {object} params 查询参数
 * @param {number} params.page 页码
 * @param {number} params.pageSize 每页数量
 * @param {number} params.status 状态：0-禁用，1-启用
 * @param {string} params.keyword 关键词（搜索套餐名称）
 * @author BlackJack
 * @date 2026-01-12
 */
export function getAgentPackageList(params) {
  return request({
    url: '/admin/agent/packages',
    method: 'get',
    params
  })
}

/**
 * 获取启用状态的代理商套餐列表
 * @author BlackJack
 * @date 2026-01-12
 */
export function getEnabledAgentPackageList() {
  return request({
    url: '/admin/agent/packages/enabled',
    method: 'get'
  })
}

/**
 * 获取代理商套餐详情
 * @param {number} id 套餐ID
 * @author BlackJack
 * @date 2026-01-12
 */
export function getAgentPackageDetail(id) {
  return request({
    url: `/admin/agent/packages/${id}`,
    method: 'get'
  })
}

/**
 * 创建代理商套餐
 * @param {object} data 套餐信息
 * @param {string} data.packageName 套餐名称
 * @param {number} data.packagePrice 套餐价格
 * @param {number} data.discountRate 批发折扣率（如0.85表示8.5折）
 * @param {string} data.description 套餐描述
 * @param {number} data.sortOrder 排序
 * @param {number} data.status 状态：0-禁用，1-启用
 * @param {array} data.cardConfigs 卡密配置列表
 * @author BlackJack
 * @date 2026-01-12
 */
export function createAgentPackage(data) {
  return request({
    url: '/admin/agent/packages',
    method: 'post',
    data
  })
}

/**
 * 更新代理商套餐
 * @param {number} id 套餐ID
 * @param {object} data 套餐信息
 * @author BlackJack
 * @date 2026-01-12
 */
export function updateAgentPackage(id, data) {
  return request({
    url: `/admin/agent/packages/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除代理商套餐
 * @param {number} id 套餐ID
 * @author BlackJack
 * @date 2026-01-12
 */
export function deleteAgentPackage(id) {
  return request({
    url: `/admin/agent/packages/${id}`,
    method: 'delete'
  })
}

/**
 * 切换代理商套餐状态
 * @param {number} id 套餐ID
 * @param {number} status 新状态：0-禁用，1-启用
 * @author BlackJack
 * @date 2026-01-12
 */
export function toggleAgentPackageStatus(id, status) {
  return request({
    url: `/admin/agent/packages/${id}/status`,
    method: 'put',
    params: { status }
  })
}

/**
 * 获取代理商功能状态
 * @author BlackJack
 * @date 2026-01-12
 */
export function getAgentStatus() {
  return request({
    url: '/admin/agent/status',
    method: 'get'
  })
}

/**
 * 切换代理商功能开关
 * @param {boolean} enabled 是否启用
 * @author BlackJack
 * @date 2026-01-12
 */
export function toggleAgentEnabled(enabled) {
  return request({
    url: '/admin/agent/status',
    method: 'put',
    params: { enabled }
  })
}


// ======================== 返佣配置管理相关接口 ========================

/**
 * 获取返佣配置
 * 获取返佣功能开关状态和各套餐的返佣比例配置
 * @author BlackJack
 * @date 2026-01-12
 */
export function getCommissionConfig() {
  return request({
    url: '/admin/commission/config',
    method: 'get'
  })
}

/**
 * 切换返佣功能开关
 * @param {boolean} enabled 是否启用
 * @author BlackJack
 * @date 2026-01-12
 */
export function toggleCommissionEnabled(enabled) {
  return request({
    url: '/admin/commission/status',
    method: 'put',
    params: { enabled }
  })
}

/**
 * 更新返佣配置
 * 批量更新各套餐的返佣比例配置
 * @param {array} configs 返佣配置列表
 * @param {number} configs[].packageId 套餐ID
 * @param {number} configs[].commissionRate 返佣比例（百分比，如10表示10%）
 * @param {number} configs[].status 状态：0-禁用，1-启用
 * @author BlackJack
 * @date 2026-01-12
 */
export function updateCommissionConfig(configs) {
  return request({
    url: '/admin/commission/config',
    method: 'put',
    data: configs
  })
}

/**
 * 获取代理商返佣配置
 */
export function getAgentCommissionConfig() {
  return request({
    url: '/admin/commission/config/agent',
    method: 'get'
  })
}

/**
 * 更新代理商返佣配置
 */
export function updateAgentCommissionConfig(configs) {
  return request({
    url: '/admin/commission/config/agent',
    method: 'put',
    data: configs
  })
}


// ======================== 提现审核管理相关接口 ========================

/**
 * 获取提现审核配置
 * 获取提现审核开关状态和审核阈值
 * @returns {Promise} 返回提现审核配置 { reviewEnabled, reviewThreshold }
 * @author BlackJack
 * @date 2026-01-12
 */
export function getWithdrawalConfig() {
  return request({
    url: '/admin/withdrawal/config',
    method: 'get'
  })
}

/**
 * 更新提现审核配置
 * @param {object} data 提现审核配置
 * @param {boolean} data.reviewEnabled 是否启用审核
 * @param {number} data.reviewThreshold 审核阈值金额
 * @returns {Promise} 操作结果
 * @author BlackJack
 * @date 2026-01-12
 */
export function updateWithdrawalConfig(data) {
  return request({
    url: '/admin/withdrawal/config',
    method: 'put',
    data
  })
}

/**
 * 获取提现列表（分页）
 * @param {object} params 查询参数
 * @param {number} params.page 页码
 * @param {number} params.pageSize 每页数量
 * @param {number} params.status 状态筛选：1-申请中，2-审核通过，3-审核拒绝，4-打款中，5-已完成，6-已取消
 * @param {number} params.userId 用户ID筛选
 * @param {string} params.startTime 开始时间（格式：yyyy-MM-dd HH:mm:ss）
 * @param {string} params.endTime 结束时间（格式：yyyy-MM-dd HH:mm:ss）
 * @returns {Promise} 提现列表分页数据
 * @author BlackJack
 * @date 2026-01-12
 */
export function getWithdrawalList(params) {
  return request({
    url: '/admin/withdrawal/list',
    method: 'get',
    params
  })
}

/**
 * 获取提现详情
 * @param {number} id 提现记录ID
 * @returns {Promise} 提现详情
 * @author BlackJack
 * @date 2026-01-12
 */
export function getWithdrawalDetail(id) {
  return request({
    url: `/admin/withdrawal/${id}`,
    method: 'get'
  })
}

/**
 * 审核通过提现申请
 * 审核通过后系统将调用微信商家转账API完成打款
 * @param {number} id 提现记录ID
 * @param {object} data 审核请求
 * @param {string} data.remark 审核备注（可选）
 * @returns {Promise} 操作结果
 * @author BlackJack
 * @date 2026-01-12
 */
export function approveWithdrawal(id, data = {}) {
  return request({
    url: `/admin/withdrawal/${id}/approve`,
    method: 'post',
    data
  })
}

/**
 * 审核拒绝提现申请
 * 审核拒绝后提现金额将退回用户可提现余额
 * @param {number} id 提现记录ID
 * @param {object} data 拒绝请求
 * @param {string} data.reason 拒绝原因（必填）
 * @returns {Promise} 操作结果
 * @author BlackJack
 * @date 2026-01-12
 */
export function rejectWithdrawal(id, data) {
  return request({
    url: `/admin/withdrawal/${id}/reject`,
    method: 'post',
    data
  })
}


// ======================== 佣金提现管理 ========================

/**
 * 获取佣金提现配置
 */
export function getCommissionWithdrawConfig() {
  return request({
    url: '/admin/commission/withdraw/config',
    method: 'get'
  })
}

/**
 * 更新佣金提现配置
 */
export function updateCommissionWithdrawConfig(data) {
  return request({
    url: '/admin/commission/withdraw/config',
    method: 'put',
    data
  })
}

/**
 * 获取佣金提现列表
 */
export function getCommissionWithdrawList(params) {
  return request({
    url: '/admin/commission/withdraw/list',
    method: 'get',
    params
  })
}

/**
 * 佣金提现审核（通过/拒绝）
 */
export function auditCommissionWithdraw(withdrawId, data) {
  return request({
    url: `/admin/commission/withdraw/${withdrawId}/audit`,
    method: 'post',
    data
  })
}

/**
 * 管理端-解绑用户微信
 */
export function unbindUserWechat(userId) {
  return request({
    url: `/admin/user/${userId}/unbindWechat`,
    method: 'post'
  })
}

/**
 * 管理端-获取用户微信绑定信息
 */
export function getUserWechatInfo(userId) {
  return request({
    url: `/admin/user/${userId}/wechatInfo`,
    method: 'get'
  })
}


// ======================== 会员系统配置管理相关接口 ========================

/**
 * 获取会员系统配置
 * 获取会员系统全局配置，包含代理商、返佣、提现审核等开关和阈值
 * @returns {Promise} 会员系统配置 { agentEnabled, commissionEnabled, withdrawalReviewEnabled, withdrawalReviewThreshold }
 * @author BlackJack
 * @date 2026-01-12
 */
export function getMembershipSystemConfig() {
  return request({
    url: '/admin/config/membership',
    method: 'get'
  })
}

/**
 * 更新会员系统配置
 * 支持部分更新，只传需要更新的字段即可
 * @param {object} data 会员系统配置
 * @param {boolean} data.agentEnabled 代理商功能开关
 * @param {boolean} data.commissionEnabled 推荐返佣功能开关
 * @param {boolean} data.withdrawalReviewEnabled 提现审核开关
 * @param {number} data.withdrawalReviewThreshold 提现审核金额阈值（元）
 * @returns {Promise} 操作结果
 * @author BlackJack
 * @date 2026-01-12
 */
export function updateMembershipSystemConfig(data) {
  return request({
    url: '/admin/config/membership',
    method: 'put',
    data
  })
}


// ======================== 套餐等级管理相关接口 ========================

/**
 * 更新套餐等级
 * @param {number} id 套餐ID
 * @param {number} level 等级值（正整数，数字越大等级越高）
 * @returns {Promise} 操作结果
 * @author BlackJack
 * @date 2026-01-15
 */
export function updatePackageLevel(id, level) {
  return request({
    url: `/admin/package/${id}/level`,
    method: 'patch',
    data: { level }
  })
}


// ======================== 用户推荐关系管理相关接口 ========================

/**
 * 获取用户推荐关系详情
 * 包含用户信息、推荐人信息、直推下级数量、佣金统计等
 * @param {number} userId 用户ID
 * @returns {Promise} 用户推荐关系详情
 * @author Claude
 * @date 2026-02-12
 */
export function getUserReferralDetail(userId) {
  return request({
    url: `/admin/commission/user/${userId}/referral`,
    method: 'get'
  })
}

/**
 * 调整用户推荐人
 * 修改用户的推荐人关系，newReferrerId为null时表示取消推荐关系
 * @param {object} data 调整请求
 * @param {number} data.userId 用户ID
 * @param {number} data.newReferrerId 新推荐人ID（null表示取消推荐关系）
 * @returns {Promise} 操作结果
 * @author Claude
 * @date 2026-02-12
 */
export function adjustUserReferrer(data) {
  return request({
    url: '/admin/commission/user/referrer',
    method: 'post',
    data
  })
}

/**
 * 更新用户状态
 * @param {object} data 状态更新请求
 * @param {number} data.userId 用户ID
 * @param {number} data.status 新状态：0-禁用，1-启用
 * @param {string} data.reason 原因说明
 * @returns {Promise} 操作结果
 */
export function updateUserStatus(data) {
  return request({
    url: '/admin/user/status',
    method: 'put',
    data
  })
}

// ======================== 搜图服务配置 ========================

export function getImageSearchServiceList() {
  return request({
    url: '/admin/image-search-services',
    method: 'get'
  })
}

export function createImageSearchService(data) {
  return request({
    url: '/admin/image-search-services',
    method: 'post',
    data
  })
}

export function updateImageSearchService(id, data) {
  return request({
    url: `/admin/image-search-services/${id}`,
    method: 'put',
    data
  })
}

export function deleteImageSearchService(id) {
  return request({
    url: `/admin/image-search-services/${id}`,
    method: 'delete'
  })
}

export function testImageSearchService(id) {
  return request({
    url: `/admin/image-search-services/${id}/test`,
    method: 'post'
  })
}

export function getImageSearchServiceStatus(id) {
  return request({
    url: `/admin/image-search-services/${id}/status`,
    method: 'get'
  })
}

export function refreshImageSearchSyncStats(params) {
  return request({
    url: '/admin/image-search-services/sync/refresh',
    method: 'post',
    params
  })
}

export function getImageSearchSyncOverview(params) {
  return request({
    url: '/admin/image-search-services/sync/overview',
    method: 'get',
    params
  })
}

export function getImageSearchSyncUsers(params) {
  return request({
    url: '/admin/image-search-services/sync/users',
    method: 'get',
    params
  })
}

export function getImageSearchSyncImages(params) {
  return request({
    url: '/admin/image-search-services/sync/images',
    method: 'get',
    params
  })
}

// ======================== 店铺链接主域名配置 ========================

export function getShopLinkDomainList() {
  return request({
    url: '/admin/shop-link-domains',
    method: 'get'
  })
}

export function createShopLinkDomain(data) {
  return request({
    url: '/admin/shop-link-domains',
    method: 'post',
    data
  })
}

export function updateShopLinkDomain(id, data) {
  return request({
    url: `/admin/shop-link-domains/${id}`,
    method: 'put',
    data
  })
}

export function deleteShopLinkDomain(id) {
  return request({
    url: `/admin/shop-link-domains/${id}`,
    method: 'delete'
  })
}

export function getCustomDomainSubmissions() {
  return request({
    url: '/admin/shop-link-domains/submissions',
    method: 'get'
  })
}

export function autoAuditCustomDomain(shopId) {
  return request({
    url: `/admin/shop-link-domains/submissions/${shopId}/auto-audit`,
    method: 'post'
  })
}

export function reviewCustomDomain(shopId, data) {
  return request({
    url: `/admin/shop-link-domains/submissions/${shopId}/review`,
    method: 'post',
    data
  })
}

export function deployCustomDomain(shopId) {
  return request({
    url: `/admin/shop-link-domains/submissions/${shopId}/deploy`,
    method: 'post'
  })
}

// ======================== 商品同步规则 ========================

export function getSyncRuleList(params) {
  return request({
    url: '/admin/sync-rules',
    method: 'get',
    params
  })
}

export function getSyncRuleDetail(id) {
  return request({
    url: `/admin/sync-rules/${id}/detail`,
    method: 'get'
  })
}

export function getSyncRuleStats(id) {
  return request({
    url: `/admin/sync-rules/${id}/stats`,
    method: 'get'
  })
}

// ======================== URL Scheme 配置相关接口 ========================

/**
 * 获取 URL Scheme 环境版本配置
 * 返回 envVersion（当前环境版本）、appId（小程序 AppId，只读）、appSecret（脱敏密钥，只读）
 */
export function getUrlSchemeConfig() {
  return request({
    url: '/admin/urlscheme-config',
    method: 'get'
  })
}

/**
 * 更新 URL Scheme 环境版本
 * @param {object} data 配置数据
 * @param {string} data.envVersion 环境版本: develop / trial / release
 */
export function updateUrlSchemeConfig(data) {
  return request({
    url: '/admin/urlscheme-config',
    method: 'put',
    data
  })
}
